import React from "react";
import OpcLockTags from "../../_shared/OpcLockTags/OpcLockTags";
import { reviewNote } from "../../_config/okrPlansCoachConfig";
import { day, plural } from "../../_config/okrPlansCoachFormat";
import "./_plan-card.scss";

// ═══════════════════════════════════════════════════════════════════════════
// Compact plan card inside a member's row (CD6, CD16): status dot + Active /
// Reviewed, the review note, after-lock markers · title · one meta line
// (review date · N reports · check-ins due) · slim progress bar. Archived
// plans (objective deleted) are greyed.
// ═══════════════════════════════════════════════════════════════════════════

const PlanCard = ({ plan, onOpen }) => {
  const r = plan.review || {};
  const done = r.state === "REVIEWED" || r.state === "NOT_REVIEWED";
  const active = !done && !plan.is_archived && !plan.is_read_only;
  const note = reviewNote(plan);
  return (
    <div className="col-lg-4 col-md-6 mb-3">
      <div
        className={`opc-pc h-100${plan.is_archived ? " opc-pc--archived" : ""}`}
        role="button"
        tabIndex={0}
        onClick={onOpen}
        onKeyDown={(e) => e.key === "Enter" && onOpen()}
      >
        <div className="opc-pc__top">
          <span
            className={`opc-pc__state ${active ? "is-active" : "is-closed"}`}
          >
            <i />
            {active ? "Active" : r.state === "REVIEWED" ? "Reviewed" : "Ended"}
          </span>
          {note && !plan.is_archived ? (
            <span className={`opc-pc__note is-${note.tone}`}>{note.text}</span>
          ) : null}
          <OpcLockTags flags={plan.flags} />
          <img
            src="/assets/images/navigate-grey.svg"
            alt=""
            className="opc-pc__go"
          />
        </div>
        <div className="opc-pc__title" title={plan.objective}>
          {plan.objective}
        </div>
        <div className="opc-pc__meta">
          {plan.is_archived ? (
            <span>Objective deleted on {day(plan.objective_deleted_at)}</span>
          ) : done ? (
            <>
              <span>
                {r.state === "REVIEWED"
                  ? `Reviewed ${day(r.finalised_at)}`
                  : "Not reviewed"}
              </span>
              <span>{plural(plan.reports_count || 0, "report")}</span>
            </>
          ) : (
            <>
              <span>Review {day(plan.review_date)}</span>
              <span>{plural(plan.reports_count || 0, "report")}</span>
              <span className={plan.checkins_due ? "is-due" : ""}>
                {plan.checkins_due
                  ? `${plural(plan.checkins_due, "check-in")} due`
                  : "No check-ins due"}
              </span>
            </>
          )}
        </div>
        <div
          className="opc-pc__progress"
          aria-label={`${plan.progress ?? 0}% progress`}
        >
          <span className="opc-pc__bar">
            <i style={{ width: `${plan.progress ?? 0}%` }} />
          </span>
          <span className="opc-pc__pct">{plan.progress ?? 0}%</span>
        </div>
      </div>
    </div>
  );
};

export default PlanCard;
